import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {AspectRatioCard} from '@homeaway/react-aspect-ratio-card';
import classnames from 'classnames';
import LazyLoad from '../../common/lazy-load/LazyLoad';
import {pushEdapEvent} from '../../../utils/edap';
import {LAZY_LOAD_OFFSET} from '../../../utils/constants';
import PlaceholderImage from '../../common/carousel/Placeholder';

import './CardPopularDestinations.less';

function replaceTemplateString(template, res) {
    return (template || '').replace('${templateId}', res);
}

export function mapStateToProps({
    config: {
        isMobile,
        site: {name: siteName},
    },
}) {
    const offset = LAZY_LOAD_OFFSET[isMobile ? 'MOBILE' : 'DEFAULT'];

    return {
        fabId: 10,
        isMobile,
        offset,
        siteName,
    };
}

export class CardPopularDestinationsComponent extends Component {
    static propTypes = {
        cardAspectRatio: PropTypes.string,
        fabId: PropTypes.number,
        fullName: PropTypes.string,
        heading: PropTypes.string,
        imageUrl: PropTypes.string,
        itemNumber: PropTypes.number,
        lbsId: PropTypes.string,
        listingCount: PropTypes.number,
        simpleName: PropTypes.string,
        highlightedItemLbsId: PropTypes.string,
        serpUrl: PropTypes.string,
        subheading: PropTypes.string,
    };

    static defaultProps = {
        cardAspectRatio: '4x3',
        listingCount: 0,
    };

    handleClick = (itemNumber) => () => {
        const data = {
            actionlocation: 'destinations-component',
            eventlbsuuid: this.props.lbsId,
            eventrefinements: `position:${itemNumber}`,
        };

        pushEdapEvent('destination.link.click', data);
    };

    onMouseEnter = () => {
        this.props.changeHighlightItem(this.props.lbsId);
    };

    onMouseLeave = () => {
        this.props.changeHighlightItem();
    };

    render() {
        const {
            cardAspectRatio,
            highlightedItemLbsId,
            heading,
            imageUrl,
            itemNumber,
            lbsId,
            offset,
            serpUrl,
            subheading,
        } = this.props;

        const cardClasses =
            highlightedItemLbsId === lbsId
                ? classnames(
                      'Card__link',
                      'CardPopularDestinations--highlighted'
                  )
                : classnames('Card__link');

        const image = replaceTemplateString(imageUrl, 'hw6');

        return (
            <a
                href={serpUrl}
                target="_blank"
                className={cardClasses}
                onClick={this.handleClick(itemNumber)}
                onMouseEnter={this.onMouseEnter}
                onMouseLeave={this.onMouseLeave}
            >
                <AspectRatioCard aspectRatio={cardAspectRatio}>
                    <div
                        data-slot={'figure'}
                        className="CardPopularDestinations__figure Card__figure"
                    >
                        <LazyLoad
                            offset={offset}
                            placeholder={<PlaceholderImage alt={heading} />}
                        >
                            <img
                                alt={heading}
                                src={image}
                                className="CardPopularDestinations__image Card__image"
                            />
                        </LazyLoad>
                        <div className="CardPopularDestinations__image__label">
                            <span>{itemNumber}</span>
                        </div>
                    </div>
                    <h4
                        data-slot={'caption'}
                        className="Card__caption CardPopularDestinations__caption"
                    >
                        {heading}
                    </h4>
                    <span data-slot={'content'} className="">
                        {subheading}
                    </span>
                </AspectRatioCard>
            </a>
        );
    }
}

export const CardPopularDestinations = connect(mapStateToProps)(
    CardPopularDestinationsComponent
);

CardPopularDestinations.displayName = 'CardPopularDestinations';

export default CardPopularDestinations;
